export default "__VITE_ASSET__Df0g_fga__"